/******************************************************************************************
 *	Customer Loyalty Three Year Commit (3YC) Program
 ******************************************************************************************/
(function() {
  

  angular.module('rcServices.customerLoyalty3yc', []).service(
    'CustomerLoyalty3yc',
    /* @ngInject */
    function($q, DemoMode, jilResellerCustomers, MiniJil, User) {
      // Get a customer's loyalty dates.
      this.getInfo = function(customerId) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.getCustomerLoyalty3yc(customerId);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 404
            });
          }
        } else {
          return jilResellerCustomers.customer3yc.get({
            customerId,
            resellerId: User.getResellerID()
          }).$promise;
        }
      };

      // Select loyalty program end date.
      // Payload is ISO 8601 end date string.
      this.updateInfo = function(customerId, payload) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.updateCustomerLoyalty3yc(customerId, payload);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 404
            });
          }
        } else {
          return jilResellerCustomers.customer3yc.update(
            {
              customerId,
              resellerId: User.getResellerID()
            },
            payload
          ).$promise;
        }
      };
    }
  );
})();
